import { ThemingContext, Shape, Inline, InlineSize } from '@doordash/design-language';
import { InputRoot, InputConnectedWrapper, InputContainer, InputContentContainer } from './styles/Input.js';
import './styles/Time.js';
import './styles/Select.js';
import './styles/Field.js';
import './styles/Password.js';
import { FieldSizeSemantic, FieldSize } from '../constants.js';
import React__default from 'react';
import { getThemeFieldTextStyles } from '../utils.js';

var InputWrapper = function InputWrapper(_ref) {
  var isBare = _ref.isBare,
      isDisabled = _ref.isDisabled,
      isAdjustableHeight = _ref.isAdjustableHeight,
      isRounded = _ref.isRounded,
      error = _ref.error,
      hasConnectedContentAbove = _ref.hasConnectedContentAbove,
      hasConnectedContentBelow = _ref.hasConnectedContentBelow,
      renderBeforeContent = _ref.renderBeforeContent,
      renderAfterContent = _ref.renderAfterContent,
      renderConnectedBefore = _ref.renderConnectedBefore,
      renderConnectedAfter = _ref.renderConnectedAfter,
      children = _ref.children,
      size = _ref.size,
      hasDefaultRenderContent = _ref.hasDefaultRenderContent,
      __focusBehavior = _ref.__focusBehavior;
  var theme = React__default.useContext(ThemingContext);
  var INLINE_MARGIN = size;
  var inputTextStyles = getThemeFieldTextStyles({
    theme: theme,
    size: size,
    styleType: 'Input'
  });
  return /*#__PURE__*/React__default.createElement(InputRoot, {
    themeHeight: theme.Size[FieldSizeSemantic[size]]
  }, renderConnectedBefore && /*#__PURE__*/React__default.createElement(InputConnectedWrapper, {
    side: "left",
    size: size,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    isRounded: isRounded
  }, renderConnectedBefore()), /*#__PURE__*/React__default.createElement(InputContainer, {
    size: size,
    error: error,
    disabled: isDisabled,
    isBare: isBare,
    roundedLeft: !!!renderConnectedBefore,
    roundedRight: !!!renderConnectedAfter,
    roundedAbove: !hasConnectedContentAbove,
    roundedBelow: !hasConnectedContentBelow,
    isRounded: isRounded || theme.Shape.Field === Shape.Pill,
    isAdjustableHeight: isAdjustableHeight,
    renderVerticalPadding: isAdjustableHeight || !!renderBeforeContent || !!renderAfterContent,
    leadingRenderContent: !!renderBeforeContent,
    trailingRenderContent: !!renderAfterContent,
    mobileInputTextStyles: inputTextStyles.mobile,
    desktopInputTextStyles: inputTextStyles.desktop,
    hasDefaultRenderContent: hasDefaultRenderContent,
    __focusBehavior: __focusBehavior
  }, renderBeforeContent && /*#__PURE__*/React__default.createElement(Inline, {
    size: INLINE_MARGIN
  }, renderBeforeContent()), /*#__PURE__*/React__default.createElement(InputContentContainer, {
    isAdjustableHeight: isAdjustableHeight,
    hasTrailingRenderContent: !!renderAfterContent,
    size: size
  }, children), renderAfterContent && /*#__PURE__*/React__default.createElement(Inline, {
    size: InlineSize.None
  }, renderAfterContent())), renderConnectedAfter && /*#__PURE__*/React__default.createElement(InputConnectedWrapper, {
    side: "right",
    size: size,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    isRounded: isRounded
  }, renderConnectedAfter()));
};

InputWrapper.Sizes = FieldSize;

export { InputWrapper as default };
